import React, { memo, useEffect, useState } from 'react';
import talentProfileApi from '../../services/talentProfiles';
import CommonLoading from '../CommonLoading/CommonLoading';
import { AiTable, Aih3, Aili, Aiul, Content, LeftSide, RightSide, SubTitle, WrapContent } from './Styled';
import { TEXT_LABEL } from './constants';
import { Divider } from 'antd';
import { BasicButton } from '../../assets/common';
import { arrow_down_filter_2 } from '../../assets/img';
import { useDispatch } from 'react-redux';
import { updatePrintData } from '../../pages/TalentProfilePage/store/printProfileSlice';
import { TP_PRINT_SECTION_NAME } from '../TalentProfilePrintPreview/constants';

const TalentSketch = ({ id, roleUser, tokenTalentProfile }) => {
  const [keyStrengthPills, setKeyStrengthPills] = useState([]);
  const [developmentAreasPills, setDevelopmentAreasPills] = useState([]);
  const [listTableView, setListTableView] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isShowMore, setShowMore] = useState(false);
  const PILLS_MAX_VIEW = 5;

  const dispatch = useDispatch();

  const getKeystrengthsDevDetails = async () => {
    setLoading(true);

    try {
      let resKeyStrengthPills = await talentProfileApi.getTalentProfileKeyStrengthPillsByStaffId({ userId: id, roleUser, tokenTalentProfile });
      let resDevelopmentAreasPills = await talentProfileApi.getTalentProfileDevelopmentAreasPillsByStaffId({
        userId: id,
        roleUser,
        tokenTalentProfile,
      });
      let resKeyStrengthList = await talentProfileApi.getTalentProfileKeyStrengthListByStaffId({ userId: id, roleUser, tokenTalentProfile });
      let resDevelopmentAreasList = await talentProfileApi.getTalentProfileDevelopmentAreasListByStaffId({
        userId: id,
        roleUser,
        tokenTalentProfile,
      });

      if (resKeyStrengthPills.status === 200) {
        const data = resKeyStrengthPills.data.result;
        setKeyStrengthPills(data);
      }

      if (resDevelopmentAreasPills.status === 200) {
        const data = resDevelopmentAreasPills.data.result;
        setDevelopmentAreasPills(data);
      }

      let keyStrengthDevelopmentAreasList = [];

      if (resKeyStrengthList.status === 200) {
        const data = resKeyStrengthList.data.result;
        if (data.length) {
          data.map((i) => keyStrengthDevelopmentAreasList.push({ keyStrength: i }));
        }
      }

      if (resDevelopmentAreasList.status === 200) {
        const data = resDevelopmentAreasList.data.result;
        if (data.length) {
          data.map((i, index) => (keyStrengthDevelopmentAreasList[index] = { ...keyStrengthDevelopmentAreasList[index], developmentAreas: i }));
        }
      }

      dispatch(
        updatePrintData({
          sectionName: TP_PRINT_SECTION_NAME.KEY_STRENGTHS,
          data: {
            keyStrengthPills: resKeyStrengthPills.data.result,
            developmentAreasPills: resDevelopmentAreasPills.data.result,
            keyStrengthList: resKeyStrengthList.data.result,
            developmentAreasList: resDevelopmentAreasList.data.result,
          },
        }),
      );
      setListTableView(keyStrengthDevelopmentAreasList);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!roleUser.roleActive.roleId || !id) {
      return;
    }

    getKeystrengthsDevDetails();
  }, [roleUser.roleActive.roleId, id]);

  const renderKeyDevOptionItem = (ele, eleIdx) => {
    return <Aili key={eleIdx}>{ele.attribute}</Aili>;
  };

  return (
    <WrapContent data-testid="talent-sketch">
      <SubTitle>
        <LeftSide>
          <Aih3>{TEXT_LABEL.KEY_STRENGTH}</Aih3>
          <Aiul>
            {keyStrengthPills.slice(0, isShowMore ? keyStrengthPills.length : PILLS_MAX_VIEW).map((subele, subidx) => {
              return renderKeyDevOptionItem(subele, subidx);
            })}
          </Aiul>
        </LeftSide>
        <RightSide>
          <Aih3>{TEXT_LABEL.DEVELOPMENT_AREA}</Aih3>
          <Aiul>
            {developmentAreasPills.slice(0, isShowMore ? developmentAreasPills.length : PILLS_MAX_VIEW).map((subele, subIdx) => {
              return renderKeyDevOptionItem(subele, subIdx);
            })}
          </Aiul>
        </RightSide>
      </SubTitle>
      {(keyStrengthPills.length && keyStrengthPills.length > 5) || (developmentAreasPills.length && developmentAreasPills.length > 5) ? (
        <div style={{ width: '100%' }}>
          <BasicButton mode="border-teal" onClick={() => setShowMore(!isShowMore)} style={{ width: '100%' }}>
            {isShowMore ? 'View Less' : 'View More'}
            <img src={arrow_down_filter_2} alt="arrow view more button" style={{ marginLeft: '8px', rotate: `${isShowMore ? '180deg' : ''}` }} />
          </BasicButton>
        </div>
      ) : (
        ''
      )}
      <Divider />
      <AiTable>
        <table>
          <thead>
            <tr>
              <th>
                <h3>{TEXT_LABEL.KEY_STRENGTH}</h3>
              </th>
              <th>
                <h3>{TEXT_LABEL.DEVELOPMENT_AREA}</h3>
              </th>
            </tr>
          </thead>
          <tbody>
            {!loading &&
              listTableView.length > 0 &&
              listTableView.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>
                      <Content className="container">
                        <p className="mb-2">{item?.keyStrength?.attribute_evidences || ''}</p>
                        <p className="source">
                          {item?.keyStrength?.attribute_evidences &&
                            `${item.keyStrength?.document ? `${item.keyStrength.document}, ` : ''}
                             ${item.keyStrength.doc_year} (${item.keyStrength.source})`}
                        </p>
                      </Content>
                    </td>
                    <td>
                      <Content className="container">
                        <p className="mb-2">{item?.developmentAreas?.attribute_evidences || ''}</p>
                        <p className="source">
                          {item?.developmentAreas?.attribute_evidences &&
                            `${item.developmentAreas?.document ? `${item.developmentAreas.document}, ` : ''}
                             ${item.developmentAreas.doc_year} (${item.developmentAreas.source})`}
                        </p>
                      </Content>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
        {loading && <CommonLoading />}
      </AiTable>
    </WrapContent>
  );
};
export default memo(TalentSketch);
